import {Component, Input, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {ConstsHelper} from '../../../../helpers/consts.helper';
import {CheckPasswordInterfaceState} from '../../store/state/check-password.state';
import {EsimService} from '../../services/esim.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-esim-qr-code',
  templateUrl: './esim-qr-code.component.html',
  styleUrls: ['./esim-qr-code.component.css'],
  standalone: false
})
export class EsimQrCodeComponent implements OnInit {

  @Input()
  phoneNumber: string;

  isVisible: boolean;
  qrCodeImage: string;
  qrCode: string;
  brand?: string;

  constructor(
      private store: Store<any>,
      private esimService: EsimService
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.qrCodeImage = null;
    this.qrCode = null;
    this.isVisible = false;
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result != null && response.result.page === 'qr-code') {
        if (response.result.isValid === true) {
          this.esimService.getQrCode(this.phoneNumber, response.result.password).subscribe(result => {
            this.isVisible = true;
            this.qrCodeImage = result.image;
            this.qrCode = result.code;
          });
        }
      }
    });
  }

  close() {
    this.isVisible = false;
    this.qrCodeImage = null;
    this.qrCode = null;
  }
}
